import { Colors, Icon } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { Flex } from "@/components/layout/flexbox";
import { Clickable } from "@/components/pieces/interaction/Clickable";
import { GREEN } from "@/css/constants";

interface PrettyCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: number;
}

export function PrettyCheckbox({
  checked,
  onChange,
  disabled = false,
  size = 30,
}: PrettyCheckboxProps) {
  const checkbox = (
    <CheckboxStyles
      width={size}
      height={size}
      alignItems="center"
      justifyContent="center"
      className={`${checked ? "checked" : ""} ${disabled ? "disabled" : ""}`}
    >
      {checked ? <Icon icon="tick" color={Colors.WHITE} /> : null}
    </CheckboxStyles>
  );

  if (disabled) {
    return checkbox;
  }
  return <Clickable onClick={() => onChange(!checked)}>{checkbox}</Clickable>;
}

const CheckboxStyles = styled(Flex)`
  border: 1px solid ${Colors.LIGHT_GRAY1};
  background-color: #fff;
  border-radius: 6px;
  transition: all 400ms ease;

  &.disabled {
    background-color: ${Colors.LIGHT_GRAY5};
  }

  &:not(.disabled):not(.checked):hover {
    box-shadow: 0 1px 7px rgba(0, 0, 0, 0.1);
    background-color: white;
    border-color: ${GREEN};
  }

  &.checked {
    background-color: ${GREEN};
    border-color: ${GREEN};
  }
`;
